module.exports = __webpack_public_path__ + "img/avatar7.30017156.png";